import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { ClassificationEmployeurService } from '../../core/service/classification-employeur.service';
import { ClassificationEmployeur } from '../../core/model/classification-employeur';

@Component({
  selector: 'app-edit-classification-employeur',
  templateUrl: './edit-classification-employeur.component.html',
  styleUrls: ['./edit-classification-employeur.component.scss']
})
export class EditClassificationEmployeurComponent implements OnInit {

  @Input()
  set classificationEmployeur(value: ClassificationEmployeur) {
    if (value) {
      this._classificationEmployeur = { ...value };
      this.loading = false;
      this.cdr.detectChanges();
    }
  }
  get classificationEmployeur(): ClassificationEmployeur {
    return this._classificationEmployeur;
  }

  private _classificationEmployeur: ClassificationEmployeur;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _classificationEmployeurService: ClassificationEmployeurService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._classificationEmployeurService
      .put(this.classificationEmployeur)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.classificationEmployeur);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

}
